import WebFont from 'webfontloader';

export const parseColor = (rgba) => {
  const { r, g, b, a } = rgba;
  return `rgba(${r}, ${g}, ${b}, ${a})`;
};

export const parseSpace = (space) => {
  const s = {};

  Object.entries(space).forEach(([key, value]) => {
    if (value === '' || value === null || value === undefined) {
      s[key] = '0';
    } else {
      s[key] = `${value}px`;
    } 
  });

  return `${s.top || 0} ${s.right || 0} ${s.bottom || 0} ${s.left || 0}`;
};

export const parseWidth = (width, unit) => {
  if (unit === '%') return `${width}${unit}`;
  return `${width}px`;
};

export const parseStyle = (styles) => {
    const parsed = {}; 
    
    Object.entries(styles).forEach(([key, value]) => {
      if (value) {
        switch (key) {
          case 'color':
          case 'borderColor':
          case 'backgroundColor':  
            parsed[key] = parseColor(value);
            break;
          case 'margin': 
          case 'padding': 
            parsed[key] = parseSpace(value);
            break;
          case 'width': 
            parsed[key] = parseWidth(value, styles.widthUnit);
            break;
          case 'widthUnit':
            break;
          case 'fontFamily':
            parsed[key] = value;
            WebFont.load({
              google: {
                families: [value]
              }
            });
            break;
          case 'fontSize':
            parsed[key] = `${value || 0}px`;
            break;
          default:
            parsed[key] = value;
            break;
        }
      }
    });
    
    return parsed;
};

